
 /*
  *****************************************************************************
  * WARNING: This file is automatically generated.
  * Do not edit this file manually.
  *****************************************************************************
  * 
  * The source file is located at:
  *   /codebuild/output/src994476363/src/vl-app/pages/axalogin.tsx
  */

import { createFileRoute } from '@tanstack/react-router';
import React from 'react';
import { NextPage } from '../stubs/next-types';
import LoginLayout from '@components/Layouts/Login';
import RestrictedAccessView from '@components/Login/views/RestrictedAccessView';

const AxaLogin: NextPage = () => (
  <LoginLayout>
    <RestrictedAccessView />
  </LoginLayout>
);

export default AxaLogin;
export const Route = createFileRoute('/axalogin')({ component: AxaLogin });
